import { Component } from '@angular/core';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../_base.component';
import { InputSelectMultipleModal } from './multiple.modal';

import { DialogBaseService } from '../../../../dialog/dialog.base.module';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-select',
  templateUrl: './select.component.html',
  host: {
    class: 'uex-input-select'
  }
})
export class InputSelectComponent extends BaseComponent<any> {

  constructor(
    private _dialogBaseService: DialogBaseService
  ) { super(); }

  public modal_opened = false;

  public onSelectMultipleKeyPress(event: any) {
    const keyCode = event.which || event.keyCode;
    switch (keyCode) {
      case 13:  // Return
      case 32:  // Space
        event.preventDefault();
        this.selectMultiple();
        break;
    }
  }

  public selectMultiple() {
    if (!this.schema.disabled && !this.modal_opened) {
      this.modal_opened = true;
      if (!this.isFocused()) { this.schema.focus(); }
      const modal = this._dialogBaseService.open(InputSelectMultipleModal, {
          schema: this.schema
        }, {
          size: 'xs',
          keyboard: {
            onEscape: 'close'
          }
        });
      const value_subscription: Subscription = modal.onReturnValue.subscribe((value) => {
        value_subscription.unsubscribe();
        this.schema.value = value;
        this.onChange();
        modal.close();
      });
      modal.onClose.then(() => {
        this.modal_opened = false;
        this.schema.focus();
      });
    }
  }

  public getOptionLabel(value: any): string {
    const found_option = this.schema.formatted_options.filter((option) => this.compareFn(option.value, value))[0];
    return found_option ? found_option.label : null;
  }

  public compareFn(obj1: any, obj2: any): boolean {
    return _.isEqual(obj1, obj2);
  }

}
